{
  "AGENT_MGMT": {
    "HEADER": "Agenti",
    "HEADER_BTN_TXT": "Pridať agenta",
    "LOADING": "Zoznam agentov sa načítava",
    "DESCRIPTION": "Agent je člen tímu zákazníckej podpory, ktorý môže zobraziť a odpovedať na správy používateľov. Nižšie uvedený zoznam zobrazuje všetkých agentov na vašom účte.",
    "LEARN_MORE": "Zistite viac o používateľských rolách",
    "AGENT_TYPES": {
      "ADMINISTRATOR": "Administrátor",
      "AGENT": "Agent"
    },
    "TABS": {
      "ACTIVE": "Aktívny",
      "DEACTIVATED": "Deaktivovaní"
    },
    "DISCONNECT_PHONE": {
      "BUTTON_TEXT": "Odpojiť telefón",
      "API": {
        "SUCCESS_MESSAGE": "Telefón agenta bol úspešne odpojený",
        "ERROR_MESSAGE": "Nepodarilo sa odpojiť telefón agenta, zkuste to prosím neskôr"
      }
    },
    "REACTIVATE": {
      "BUTTON_TEXT": "Aktivovat",
      "API": {
        "SUCCESS_MESSAGE": "Agent bol úspešne aktivován",
        "ERROR_MESSAGE": "Nepodarilo sa aktivovat agenta, zkuste to prosím neskôr"
      },
      "CONFIRM": {
        "TITLE": "Potvrdiť aktivaci",
        "MESSAGE": "Naozaj chcete aktivovat ",
        "YES": "Ano, aktivovat ",
        "NO": "Ne, zrušiť "
      }
    },
    "LIST": {
      "404": "K tomuto účtu nie sú priradení žiadni agenti",
      "TITLE": "Spravujte agentov vo svojom tíme",
      "DESC": "Môžete pridávať/odstraňovať agentov z/do svojho tímu.",
      "NAME": "Meno",
      "EMAIL": "EMAIL",
      "STATUS": "Stav",
      "ACTIONS": "Akcie",
      "VERIFIED": "Overené",
      "VERIFICATION_PENDING": "Čaká sa na overenie",
      "API_ALLOWED": "Prístup k API povolený",
      "DEACTIVATED_ON": "Deaktivován",
      "AVAILABLE_CUSTOM_ROLE": "Dostupné oprávnenia vlastnej roly"
    },
    "ADD": {
      "TITLE": "Pridať agenta do tímu",
      "DESC": "Môžete pridať ľudí, ktorí budú môcť poskytovať podporu pre vaše schránky.",
      "CANCEL_BUTTON_TEXT": "Zrušiť",
      "FORM": {
        "NAME": {
          "LABEL": "Meno agenta",
          "PLACEHOLDER": "Zadajte meno agenta"
        },
        "AGENT_TYPE": {
          "LABEL": "Agent Type",
          "PLACEHOLDER": "Please select a type",
          "ERROR": "Agent type is required"
        },
        "EMAIL": {
          "LABEL": "E-mailová adresa",
          "PLACEHOLDER": "Zadajte e-mailovú adresu agenta"
        },
        "SUBMIT": "Pridať agenta"
      },
      "API": {
        "SUCCESS_MESSAGE": "Agent bol úspešne pridaný",
        "EXIST_MESSAGE": "E-mail agenta sa už používa, skúste inú e-mailovú adresu",
        "ERROR_MESSAGE": "Nepodarilo sa pripojiť k serveru Woot, skúste to prosím neskôr"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Vymazať",
      "API": {
        "SUCCESS_MESSAGE": "Agent úspešne odstránený",
        "ERROR_MESSAGE": "Nepodarilo sa pripojiť k serveru Woot, skúste to prosím neskôr"
      },
      "CONFIRM": {
        "TITLE": "Potvrdiť vymazanie",
        "MESSAGE": "Určite chcete vymazať ",
        "DESCRIPTION": "Agent bude okamžite odhlášen, odebrán ze všetkých tímov a inboxô a nebude moci pristupovat k tomuto účtu.",
        "YES": "Áno, vymazať ",
        "NO": "Nie, ponechať "
      }
    },
    "EDIT": {
      "TITLE": "Upraviť agenta",
      "FORM": {
        "NAME": {
          "LABEL": "Meno agenta",
          "PLACEHOLDER": "Zadajte meno agenta"
        },
        "AGENT_TYPE": {
          "LABEL": "Rola",
          "PLACEHOLDER": "Vyberte rolu",
          "ERROR": "Rola je povinná"
        },
        "EMAIL": {
          "LABEL": "E-mailová adresa",
          "PLACEHOLDER": "Zadajte e-mailovú adresu agenta"
        },
        "AGENT_AVAILABILITY": {
          "LABEL": "Dostupnosť",
          "PLACEHOLDER": "Vyberte prosím stav dostupnosti",
          "ERROR": "Dostupnosť je povinná"
        },
        "API_ACCESS": {
          "LABEL": "Povoliť prístup k API",
          "HELP": "Prístup k API je predvolene vypnutý. Zapnutím povolíte použitie osobného API kľúča tohto agenta, a to pre všetky účty, do ktorých patrí. Prihlásenie do aplikácie to neovplyvní."
        },
        "SUBMIT": "Upraviť agenta"
      },
      "BUTTON_TEXT": "Upraviť",
      "CANCEL_BUTTON_TEXT": "Zrušiť",
      "API": {
        "SUCCESS_MESSAGE": "Agent bol úspešne aktualizovaný",
        "ERROR_MESSAGE": "Nepodarilo sa pripojiť k serveru Woot, skúste to prosím neskôr"
      },
      "PASSWORD_RESET": {
        "ADMIN_RESET_BUTTON": "Obnoviť heslo",
        "ADMIN_SUCCESS_MESSAGE": "Agentovi bol odoslaný e-mail s pokynmi na obnovenie hesla",
        "SUCCESS_MESSAGE": "Heslo agenta bolo úspešne obnovené",
        "ERROR_MESSAGE": "Nepodarilo sa pripojiť k serveru Woot, skúste to prosím neskôr"
      }
    },
    "SEARCH": {
      "NO_RESULTS": "Žiadne výsledky neboli nájdené."
    },
    "MULTI_SELECTOR": {
      "PLACEHOLDER": "Žiadne",
      "TITLE": {
        "AGENT": "Vybrať agenta",
        "TEAM": "Vybrať tím"
      },
      "LIST": {
        "NONE": "Žiadne"
      },
      "SEARCH": {
        "NO_RESULTS": {
          "AGENT": "Žiadni agenti neboli nájdení",
          "TEAM": "Žiadne tímy neboli nájdené"
        },
        "PLACEHOLDER": {
          "AGENT": "Hľadať agentov",
          "TEAM": "Hľadať tímy",
          "INPUT": "Hľadať agentov"
        }
      }
    }
  }
}
